export const PROFILE_ROW = {
  DISPLAY_NAME: '{{lastName}} {{firstName}}',
  GRADE_LABEL_DATE: '{{gradeLabel}} depuis le {{gradeDate}}',
};
